import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { hooks } from '@engelvoelkersamericas/common-story-ui';
import { Provider as VideoProvider } from './context/videoContext';
const { ProfileProvider, GlobalProvider } = hooks;
ReactDOM.render(
  <React.StrictMode>
    <GlobalProvider>
      <ProfileProvider>
        {/* <VideoProvider> */}
        <App />
        {/* </VideoProvider> */}
      </ProfileProvider>
    </GlobalProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
